import { Trans, useTranslation } from '@mint-lib/i18n';
import { Illustration } from '@mint-lib/illustrations';

import { Box, Button, Icon, Link, Typography } from '@myn/mui';

export const ErrorPlaceholder = ({ retry }: { retry: () => void }) => {
  const { t } = useTranslation('@mint-lib/error-boundary');

  return (
    <Box
      className="full"
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
      gap={(theme) => theme.spacing(8)}
    >
      <Box
        display="inline-flex"
        flexDirection="column"
        justifyContent="center"
        gap={(theme) => theme.spacing(3)}
      >
        <Box
          display="inline-flex"
          flexDirection="column"
          justifyContent="center"
        >
          <Box
            display="inline-flex"
            gap={(theme) => theme.spacing(1)}
            alignItems={'center'}
            mb={2}
          >
            <Icon
              component={'WarningAltFilled'}
              color={'warning'}
              fontSize="large"
            />
            <Typography variant="h3" color={'warning.main'}>
              {t('Local Error')}
            </Typography>
          </Box>
          <Typography variant="h1" mb={2}>
            {t('Something went wrong')}
          </Typography>
          <Typography variant="bodyShort01" mb={0.5}>
            {t(`This page isn't working at the moment.`)}
          </Typography>
          <Typography variant="bodyShort01" mb={4}>
            {t('Nothing to worry about, just reload it.')}
          </Typography>
          <Box mb={2}>
            <Button
              onClick={retry}
              variant="contained"
              size="large"
              color="primary"
            >
              {t('Reload the page')}
            </Button>
          </Box>

          <Typography variant="bodyLong01">
            <Trans
              ns="@mint-lib/error-boundary"
              i18Key="If the problem continues, visit our help center"
            >
              If the problem continues,{' '}
              <Link
                variant="bodyShort02"
                href="https://support.mint.ai"
                target="_blank"
                rel="noreferrer"
              >
                visit our help center
              </Link>
            </Trans>
          </Typography>
        </Box>
      </Box>
      <Illustration className="size-80" component="IllustrationLocalError" />
    </Box>
  );
};
